import { ALIGNMENT } from '../../../utils/constants/alignment';
import { API_ROSTER_POSITION_KEYS } from '../../../utils/constants/api';
import { formatValue } from '../../../utils/helpers/stats.dataManipulation';
import { GENERAL_POSITION_TO_CATEGORY } from '../../League/PlayerStats/PlayerStats.constants';

// format and return only the stat values that will display in the table.
export const formatPlayerVideoStatValues = (
  stats,
  headerIds,
  statsToQuery,
  aggMode,
  headers,
) =>
  stats?.map((stat) =>
    Object.entries(stat).reduce((acc, [key, value]) => {
      if (headerIds.includes(key)) {
        return {
          ...acc,
          [key]: {
            label: formatValue(
              value,
              statsToQuery?.find((def) => def.name === key)?.units,
              aggMode,
            ),
            hasVideo:
              statsToQuery?.find((def) => def.name === key)?.hasVideo || false,
            name: key,
            isHidden: !!headers?.find((header) => header.id === key)?.isHidden,
            alignment:
              key === 'gameDate' || key === 'gameName'
                ? ALIGNMENT.LEFT
                : ALIGNMENT.RIGHT,
          },
        };
      }
      return acc;
    }, {}),
  );

export const getPlayerVideoStatHeaders = (statDefinitions) =>
  statDefinitions?.map((stat) => ({
    id: stat.name,
    label: stat.abbrev,
    isSortable: true,
    description: `${stat.prettyName}\n${stat.description}`,
    hasVideo: stat ? stat.hasVideo : false,
    alignment: ALIGNMENT.RIGHT,
  })) || [];

// return the api category definitions shown for a position, in the order they are
// listed in GENERAL_POSITION_TO_CATEGORY (a position can map to one or many categories)
export const getPositionCategoryDefinitions = (
  generalPosition,
  categoryDefinitions,
) => {
  const categoryNames = [
    GENERAL_POSITION_TO_CATEGORY[generalPosition] || [],
  ].flat();

  return categoryNames
    .map((name) => categoryDefinitions?.find((cat) => cat.name === name))
    .filter(Boolean);
};

// parent category tabs are hidden when a position has a single category, to keep the
// existing layout - except for offensive linemen, who always get their Blocking tab
export const shouldHideParentTabs = (generalPosition, categoryCount) =>
  categoryCount <= 1 &&
  generalPosition !== API_ROSTER_POSITION_KEYS.OFFENSIVE_LINEMAN;
